import { FilterKeyValueProps, PlaybookSectionTasks } from '@Helper/Interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@Store/store';

type ListTaskProps = {
  listTaskCollecion: PlaybookSectionTasks | undefined;
  rowFilters: FilterKeyValueProps[];
  columnFilters: FilterKeyValueProps[];
  searchString: string;
  tableFilterRowPanerl: any;
  scrollPosition: number | undefined;
};

const initialState: ListTaskProps = {
  listTaskCollecion: undefined,
  rowFilters: [],
  columnFilters: [],
  searchString: '',
  tableFilterRowPanerl: {},
  scrollPosition: undefined,
};

export const listTaskSlice = createSlice({
  name: 'listTaskSlice',
  initialState,
  reducers: {
    postListTaskCollection: (
      state,
      action: PayloadAction<PlaybookSectionTasks | undefined>
    ) => {
      state.listTaskCollecion = action.payload;
    },
    postRowFilters: (state, action: PayloadAction<FilterKeyValueProps[]>) => {
      state.rowFilters = action.payload;
    },
    postTableFilterRowPanel: (state, action: PayloadAction<any>) => {
      state.tableFilterRowPanerl = action.payload;
    },
    postColumnFilters: (
      state,
      action: PayloadAction<FilterKeyValueProps[]>
    ) => {
      state.columnFilters = action.payload;
    },
    postSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload;
    },
    postScrollPosition: (state, action: PayloadAction<number | undefined>) => {
      state.scrollPosition = action.payload;
    },
  },
});

export const { postListTaskCollection } = listTaskSlice.actions;
export const { postRowFilters } = listTaskSlice.actions;
export const { postColumnFilters } = listTaskSlice.actions;
export const { postSearchString } = listTaskSlice.actions;
export const { postTableFilterRowPanel } = listTaskSlice.actions;
export const { postScrollPosition } = listTaskSlice.actions;

export const getListTaskCollection = (state: RootState) =>
  state.listTaskReducer.listTaskCollecion;
export const getRowFilter = (state: RootState) =>
  state.listTaskReducer.rowFilters;
export const getColumnFilter = (state: RootState) =>
  state.listTaskReducer.columnFilters;
export const getSearchString = (state: RootState) =>
  state.listTaskReducer.searchString;
export const getTableFilterRowPanel = (state: RootState) =>
  state.listTaskReducer.tableFilterRowPanerl;
export const getScrollPosition = (state: RootState) =>
  state.listTaskReducer.scrollPosition;

export default listTaskSlice.reducer;
